import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { ArrowUp, ArrowDown } from "lucide-react"
import { SORT_OPTIONS } from "@/lib/project-configs"

type Props = {
  sortColumn: string
  sortDirection: string
  onSortChange: (column: string) => void
  onToggleDirection: () => void
}

export function SortControls({ sortColumn, sortDirection, onSortChange, onToggleDirection }: Props) {
  return (
    <div className="inline-flex rounded-lg border">
      <Select value={sortColumn} onValueChange={onSortChange}>
        <SelectTrigger className="h-[38px] w-[160px] rounded-none rounded-l-lg border-0">
          <SelectValue placeholder="Trier par..." />
        </SelectTrigger>
        <SelectContent>
          {SORT_OPTIONS.map((opt) => (
            <SelectItem key={opt.value} value={opt.value}>
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {sortColumn && (
        <button
          onClick={onToggleDirection}
          className="inline-flex cursor-pointer items-center justify-center border-l px-3 text-sm font-medium transition-colors bg-background text-muted-foreground hover:bg-muted hover:text-foreground rounded-r-lg h-[38px]"
        >
          {sortDirection === "asc" ? <ArrowUp className="size-4" /> : <ArrowDown className="size-4" />}
        </button>
      )}
    </div>
  )
}
